import { useApiClient } from '_core/api/context';
import { Breadcrumbs, BreadcrumbsItem } from '_core/breadcrumbs';
import { submissionErrorsFromApiError } from '_core/final-form/submissionErrorsFromApiError';
import { parseJsonWithFallback } from '_core/parseJsonWithFallback';
import { FormattedTitle } from '_core/react-head/formattedTitle';
import { useFormNavigationLock } from '_core/router5/navigationLock';
import { createContact } from 'contacts/api';
import { Row, VGrid } from 'layout/contentLayout';
import * as React from 'react';
import { useMemo } from 'react';
import { useRouteNode } from 'react-router5';

import { ContactForm } from './form';

export default function ContactsCreateRoute() {
  const { route, router } = useRouteNode('contacts.create');
  const navigationLock = useFormNavigationLock('contacts.create');
  const api = useApiClient();
  const title = 'Новый контакт';

  const listParams = useMemo(
    () => parseJsonWithFallback(route.params.listParams, {}),
    [route.params.listParams]
  );

  function handleSubmissionError(err: unknown) {
    return submissionErrorsFromApiError(
      err,
      'Не удалось создать контакт: Непредвиденная ошибка'
    );
  }

  return (
    <>
      <FormattedTitle>{title}</FormattedTitle>

      <VGrid>
        <Row>
          <Breadcrumbs>
            <BreadcrumbsItem
              label="Контакты"
              params={listParams}
              to="contacts"
            />

            <BreadcrumbsItem label={title} />
          </Breadcrumbs>
        </Row>

        <Row>
          <ContactForm
            initialValues={{
              email: '',
              firstName: '',
              firstNameRp: '',
              jobTitle: '',
              jobTitleRp: '',
              lastName: '',
              lastNameRp: '',
              middleName: '',
              middleNameRp: '',
              note: '',
              partner: null,
              phone: '',
              phoneExtra: '',
            }}
            navigationLock={navigationLock}
            onSave={async values => {
              try {
                await createContact(api, values);
                navigationLock.unlock();
                router.navigate('contacts', listParams);
                return undefined;
              } catch (err) {
                return handleSubmissionError(err);
              }
            }}
            onSaveAndContinue={async values => {
              try {
                const createdContact = await createContact(api, values);
                navigationLock.unlock();
                router.navigate('contacts.edit', {
                  id: createdContact.id,
                  listParams: route.params.listParams,
                });
                return undefined;
              } catch (err) {
                return handleSubmissionError(err);
              }
            }}
          />
        </Row>
      </VGrid>
    </>
  );
}
